// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Hels","alert":"SettungsInbox_alert__4M8qA"};